import React, { useMemo, useState } from "react";
import PageHero from "../components/shared/PageHero";
import FaqSidebar from "../components/faq/FaqSidebar";
import FaqContactBar from "../components/faq/FaqContactBar";
import Accordion from "../components/shared/Accordion";
import { faqCategories, faqItems } from "../faqData";

export default function Faq() {
  const [activeCategory, setActiveCategory] = useState("General");

  const filtered = useMemo(
    () => faqItems.filter((item) => item.category === activeCategory),
    [activeCategory]
  );

  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title="Frequently Asked Questions"
        subtitle="Questions about services, partnerships, or your account? Reach out and our team will get back to you."
      />

      <section className="mu-section">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-3">
              <FaqSidebar categories={faqCategories} active={activeCategory} onSelect={setActiveCategory} />
            </div>
            <div className="col-lg-9">
              {filtered.length === 0 ? (
                <p className="section-sub">
                  We don't have questions filed under this category yet — try Contact if yours isn't covered.
                </p>
              ) : (
                <Accordion items={filtered.map((f) => ({ q: f.q, a: f.a }))} />
              )}

              <div className="mt-4">
                <FaqContactBar />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
